<ng-container *ngIf="addPanel == 'sideways'">
  <nz-radio-group [(ngModel)]="exclusionType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
    <label nz-radio-button [nzValue]="'POLICYEXCLUSIONS'">
      <i nz-icon nzType="user" nzTheme="outline"></i> Policy Exclusions
    </label>
    <label nz-radio-button [nzValue]="'PRODUCTEXCLUSIONS'">
      <i nz-icon nzType="file-protect" nzTheme="outline"></i> Product Exclusions
    </label>
  </nz-radio-group>


  <div *ngIf="exclusionType == 'POLICYEXCLUSIONS'; else showProductExclusions" class="flexie-auto-grid m-t-b-60">

    <div class="flex-self-vert-start">
      <div *ngIf="exclusionList && exclusionList.length < 1">
        <div class="zero-ui">
          <i nz-icon nzType="schedule" nzTheme="outline"></i>
          <h2 translate>Add Exclusions</h2>
          <p translate>No Exclusions Added</p>
        </div>
      </div>
      <div *ngIf="exclusionList && exclusionList.length > 0">
        <h3 translate> Exclusions</h3>

        <div *ngFor="let item of exclusionList; let i = index;"
          class="flex flex-dir-horiz flex-horiz-space-bw flex-vert-center b-b-1 p-10">
          <div>
            <strong>{{(item.exclusionEventCd | technicalTranslate) || '-'}}</strong>
            <br>
            {{(item.exclusionEventCategory | technicalTranslate) || "-"}}
          </div>
          <div>
            <a href="javascript:void(0)" (click)="editExclusion(item,i)">Edit</a> &nbsp; | <a href="javascript:void(0)"
              (click)="removeExclusion(i)">Delete</a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-self-vert-start" style="align-self: flex-start;">
      <div class="form-secondary">
        <h3 class="form-secondary-heading" translate>+ Add Exclusion</h3>
        <form [formGroup]="exclusionForm" class="form-secondary-fields p-l-r-20 p-t-b-10">
          <nz-form-item>
            <nz-form-label nzFor="exclusionEventCd" [nzSpan]="24" [nzRequired]="isRequired('exclusionEventCd')"><span
                translate>Event</span>
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch id="exclusionEventCd" formControlName="exclusionEventCd" style="width: 100%">
                <nz-option
                  *ngFor="let item of (lookup$['exclusionEventCd'] | async) as exclusionEventCdLookup; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
              </nz-select>
              <!--  -->
              <nz-form-explain
                *ngIf="(exclusionForm.get('exclusionEventCd').dirty || exclusionForm.get('exclusionEventCd').touched) && exclusionForm.get('exclusionEventCd').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(exclusionForm.get('exclusionEventCd'), EXCLUSIONFORMNAME)">
                  {{error || '' |translate}}</p>
              </nz-form-explain>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="exclusionEventCategory" [nzSpan]="24"
              [nzRequired]="isRequired('exclusionEventCategory')"><span translate>Event Category</span>
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-select nzShowSearch id="exclusionEventCategory" formControlName="exclusionEventCategory" style="width: 100%">
                <nz-option
                  *ngFor="let item of (lookup$['exclusionEventCategoryCd'] | async) as exclusionEventCategoryLookup; trackBy:item?.lookupKey"
                  [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
              </nz-select>
              <!--  -->
              <nz-form-explain
                *ngIf="(exclusionForm.get('exclusionEventCategory').dirty || exclusionForm.get('exclusionEventCategory').touched) && exclusionForm.get('exclusionEventCategory').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(exclusionForm.get('exclusionEventCategory'), EXCLUSIONFORMNAME)">
                  {{error || '' |translate}}</p>
              </nz-form-explain>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-label nzFor="exclusionValidity" [nzSpan]="24" [nzRequired]="isRequired('exclusionValidity')"><span
                translate>Exclusion Validity</span>
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-radio-group formControlName="exclusionValidity" [nzButtonStyle]="'solid'">
                <label nz-radio-button [nzValue]="'FIXED'">Fixed Span</label>
                <label nz-radio-button [nzValue]="'POLICYDURATION'">Policy Duration</label>
              </nz-radio-group>
              <!--  -->
              <nz-form-explain
                *ngIf="(exclusionForm.get('exclusionValidity').dirty || exclusionForm.get('exclusionValidity').touched) && exclusionForm.get('exclusionValidity').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(exclusionForm.get('exclusionValidity'), EXCLUSIONFORMNAME)">
                  {{error || '' |translate}}</p>
              </nz-form-explain>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item *ngIf="exclusionForm.get('exclusionValidity').value == 'FIXED'">
            <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('exclusionValidityExpiryDt')">Exclusion Expiry Date
            </nz-form-label>
            <nz-form-control [nzSpan]="24">
              <nz-date-picker id="exclusionValidityExpiryDt" formControlName="exclusionValidityExpiryDt" nzShowTime
                [nzFormat]="'DD MMM yyyy'">
              </nz-date-picker>
              <nz-form-explain
                *ngIf="(exclusionForm.get('exclusionValidityExpiryDt').dirty || exclusionForm.get('exclusionValidityExpiryDt').touched) && exclusionForm.get('exclusionValidityExpiryDt').errors">
                <p style="color:red"
                  *ngFor="let error of validationUtilService.getUIErrorList(exclusionForm.get('exclusionValidityExpiryDt'), EXCLUSIONFORMNAME)">
                  {{error}}</p>
              </nz-form-explain>
            </nz-form-control>
          </nz-form-item>
        </form>


        <div class="footer-actions-bar">
          <div>
            <!-- Left -->
          </div>
          <div>
            <!-- Right -->
            <button nz-button class="b-0 m-r-10" (click)="clearForm()"><span translate>Clear</span></button>
            <button nz-button [nzType]="'primary'" (click)="addExclusion(exclusionForm)"><span
                translate>Add</span></button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <ng-template #showProductExclusions>
    <ng-container>
      <div class="flexie-auto-grid m-t-b-60">
        Product Exclusions
      </div>
    </ng-container>
  </ng-template>


</ng-container>

<ng-container *ngIf="addPanel == 'inline-grid'">
  <form [formGroup]="exclusionListForm">
    <nz-table [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{ x: '1700px' }" class="table-valign-top">
      <thead>
        <tr>
          <th></th>
          <th style="width: 330px">Event</th>
          <th style="width: 330px">Event Category</th>
          <th>Validity Type</th>
          <th>Valid From</th>
          <th>Valid To</th>
          <th style="width: 200px">Remarks</th>
        </tr>
      </thead>
      <tbody *ngFor="let exclusionItem of exclusionListForm.get('exclusions').controls; let i=index">
        <tr [formGroup]="exclusionItem">
          <td data-dd="Actions">
            <div *ngIf="i==0">
              <button nz-button nzType="dashed" (click)="addRow()">
                <i nz-icon nzType="plus" nzTheme="outline"></i>
              </button>
            </div>
            <div *ngIf="i>0">
              <button nz-button nzType="dashed" nz-popconfirm nzPopconfirmTitle="Remove row?" nzOkText="Remove"
                nzCancelText="Cancel" (nzOnConfirm)="removeRow()">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
          </td>
          <td data-dd="Event">
            <nz-form-item>
              <!-- <nz-form-label nzFor="exclusionEventCd" [nzSpan]="18" [nzRequired]="isRequired('exclusionEventCd')"><span
                  translate>Event</span> 
              </nz-form-label>-->
              <nz-form-control [nzSpan]="18">
                <nz-select nzShowSearch id="exclusionEventCd" formControlName="exclusionEventCd" style="width: 100%">
                  <nz-option
                    *ngFor="let item of (lookup$['exclusionEventCd'] | async) as exclusionEventCdLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(exclusionItem.get('exclusionEventCd').dirty || exclusionItem.get('exclusionEventCd').touched) && exclusionItem.get('exclusionEventCd').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(exclusionItem.get('exclusionEventCd'), EXCLUSIONFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </td>
          <td data-dd="Event Category">
            <nz-form-item>
              <!-- <nz-form-label nzFor="exclusionEventCategory" [nzSpan]="18"
                [nzRequired]="isRequired('exclusionEventCategory')"><span translate>Event Category</span>
              </nz-form-label> -->
              <nz-form-control [nzSpan]="18">
                <nz-select nzShowSearch id="exclusionEventCategory" formControlName="exclusionEventCategory" style="width: 100%">
                  <nz-option
                    *ngFor="let item of (lookup$['exclusionEventCategoryCd'] | async) as exclusionEventCategoryLookup; trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                </nz-select>
                <!--  -->
                <nz-form-explain
                  *ngIf="(exclusionItem.get('exclusionEventCategory').dirty || exclusionItem.get('exclusionEventCategory').touched) && exclusionItem.get('exclusionEventCategory').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(exclusionItem.get('exclusionEventCategory'), EXCLUSIONFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </td>
          <td data-dd="Validity Type">
            <nz-form-item>
              <!-- <nz-form-label nzFor="exclusionValidity" [nzSpan]="18" [nzRequired]="isRequired('exclusionValidity')"><span
                  translate>Exclusion Validity</span>
              </nz-form-label> -->
              <nz-form-control [nzSpan]="18">
                <nz-radio-group formControlName="exclusionValidity" [nzSize]="'small'">
                  <label nz-radio [nzValue]="'FIXED'">Fixed Span</label>
                  <label nz-radio [nzValue]="'POLICYDURATION'">Policy Duration</label>
                  <label nz-radio [nzValue]="'FIRSTYEARS'">First Few Years</label>
                </nz-radio-group>
                <!--  -->
                <nz-form-explain
                  *ngIf="(exclusionItem.get('exclusionValidity').dirty || exclusionItem.get('exclusionValidity').touched) && exclusionItem.get('exclusionValidity').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(exclusionItem.get('exclusionValidity'), EXCLUSIONFORMNAME)">
                    {{error || '' |translate}}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
          </td>
          <td data-dd="Valid From">
            <nz-form-item *ngIf="exclusionItem.get('exclusionValidity').value == 'FIXED'">
              <!-- <nz-form-label [nzSpan]="18" [nzRequired]="isRequired('exclusionValidityStartDt')">Exclusion Start Date
              </nz-form-label> -->
              <nz-form-control [nzSpan]="18">
                <nz-date-picker id="exclusionValidityStartDt" formControlName="exclusionValidityStartDt" nzShowTime
                  [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                </nz-date-picker>
                <nz-form-explain
                  *ngIf="(exclusionItem.get('exclusionValidityStartDt').dirty || exclusionItem.get('exclusionValidityStartDt').touched) && exclusionItem.get('exclusionValidityStartDt').errors">
                  <p style="color:red"
                    *ngFor="let error of validationUtilService.getUIErrorList(exclusionItem.get('exclusionValidityStartDt'), EXCLUSIONFORMNAME)">
                    {{error}}</p>
                </nz-form-explain>
              </nz-form-control>
            </nz-form-item>
            <ng-container *ngIf="exclusionItem.get('exclusionValidity').value == 'FIRSTYEARS'">
              <h5>From Policy Start Date</h5>
            </ng-container>
            
            
          </td>
          <ng-container *ngIf="exclusionItem.get('exclusionValidity').value == 'FIRSTYEARS'; else fixedTemplate">
            <td data-dd="No. Of Years">
              <nz-form-item *ngIf="exclusionItem.get('exclusionValidity').value == 'FIRSTYEARS'">
                <!-- <nz-form-label [nzSpan]="18" [nzRequired]="isRequired('exclusionValidityExpiryDt')">Exclusion Expiry Date
                </nz-form-label> -->
                <nz-form-control [nzSpan]="48">
                  <nz-select nzShowSearch id="firstYears" style="width: 100%">
                    <nz-option [nzLabel]="'First 1 Year'" [nzValue]="1"></nz-option>
                    <nz-option [nzLabel]="'First 2 Years'" [nzValue]="2"></nz-option>
                    <nz-option [nzLabel]="'First 3 Years'" [nzValue]="3"></nz-option>
                    <nz-option [nzLabel]="'First 4 Years'" [nzValue]="4"></nz-option>
                    <nz-option [nzLabel]="'First 5 Years'" [nzValue]="5"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </td>
          </ng-container>
          <ng-template #fixedTemplate>
            <td data-dd="Valid To">
              <nz-form-item *ngIf="exclusionItem.get('exclusionValidity').value == 'FIXED'">
                <!-- <nz-form-label [nzSpan]="18" [nzRequired]="isRequired('exclusionValidityExpiryDt')">Exclusion Expiry Date
                </nz-form-label> -->
                <nz-form-control [nzSpan]="18">
                  <nz-date-picker id="exclusionValidityExpiryDt" formControlName="exclusionValidityExpiryDt" nzShowTime
                    [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
                  </nz-date-picker>
                  <nz-form-explain
                    *ngIf="(exclusionItem.get('exclusionValidityExpiryDt').dirty || exclusionItem.get('exclusionValidityExpiryDt').touched) && exclusionItem.get('exclusionValidityExpiryDt').errors">
                    <p style="color:red"
                      *ngFor="let error of validationUtilService.getUIErrorList(exclusionItem.get('exclusionValidityExpiryDt'), EXCLUSIONFORMNAME)">
                      {{error}}</p>
                  </nz-form-explain>
                </nz-form-control>
              </nz-form-item>
              <nz-form-item *ngIf="exclusionItem.get('exclusionValidity').value == 'FIRSTYEARS'">
                <!-- <nz-form-label [nzSpan]="18" [nzRequired]="isRequired('exclusionValidityExpiryDt')">Exclusion Expiry Date
                </nz-form-label> -->
                <nz-form-control [nzSpan]="48">
                  <nz-select nzShowSearch id="firstYears" style="width: 100%">
                    <nz-option [nzLabel]="'First 1 Year'" [nzValue]="1"></nz-option>
                    <nz-option [nzLabel]="'First 2 Years'" [nzValue]="2"></nz-option>
                    <nz-option [nzLabel]="'First 3 Years'" [nzValue]="3"></nz-option>
                    <nz-option [nzLabel]="'First 4 Years'" [nzValue]="4"></nz-option>
                    <nz-option [nzLabel]="'First 5 Years'" [nzValue]="5"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </td>
          </ng-template>
          
          
          <td data-dd="Remarks">
            <textarea nz-input cols="2" rows="2" placeholder="Remarks ..."></textarea>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </form>

</ng-container>